// extracted by mini-css-extract-plugin
export default {"separator":"separator_separator__Auykl","square":"separator_square__lVGq0"};